import { useState, useEffect } from 'react'
import { Alert, Table  } from 'reactstrap'
import { handleGraphQLErrors, convertTextToDate, getDifferenceInDays } from '../../utils'
import { gql } from '@apollo/client'
import Spinner from '../Spinner/Spinner.js'
import { GET_LOG_FILE_QUERY, GET_LOG_FILE_LIST_QUERY } from '../../graphql.js'

export const GET_LOG_FILE_LIST = gql(GET_LOG_FILE_LIST_QUERY)
export const GET_LOG_FILE = gql(GET_LOG_FILE_QUERY)

export default function ErrorReport(props) {
  console.log('LogFile rendered: ', props)

  const [showSpinner, setShowSpinner] = useState(false)
  const [fileLines, setfileLines] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const today = new Date()
  const sevenDaysAgo = new Date(today)
  sevenDaysAgo.setDate(today.getDate() - 7)
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
  const todayString = new Intl.DateTimeFormat('en-US', options).format(today)
  const sevenDaysAgoString = new Intl.DateTimeFormat('en-US', options).format(sevenDaysAgo)  

  useEffect(() => {
    async function fetchFileLines() {
      console.log('LogFile.useEffect.fetchFileLines')
      try {
        setShowSpinner(true)
        const result = await window.apolloClient.query({ query: GET_LOG_FILE_LIST })
        let fileInfo = ''
        for (let file of result.data.getLogFileList) {
          if (file.name === 'Database-ERRORS.log') {
            fileInfo = file
            break
          }
        }
        console.log('GET_LOG_FILE_LIST', result)
        const { data, errors } = await window.apolloClient.query({ query: GET_LOG_FILE, variables: { fileInfo: fileInfo } })
        if (data.getLogFile) {
          //console.log(data.getLogFile)
          setfileLines(data.getLogFile)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setShowSpinner(false)
      }
    }
    if (!fileLines && graphQLErrors.length === 0) {
      fetchFileLines()
    }
  }, [fileLines, graphQLErrors])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger" style={{ marginTop: '50px'}}>{graphQLErrors[0].message}</Alert>
  } else if (showSpinner) {
    return <Spinner />
  } else if (fileLines) {

    const rows = []
    for (let i = fileLines.length - 1; i >= 0; i--) {
      let line = fileLines[i]
      rows.push(<pre key={i} style={{ margin: '0'}}>{line.message}</pre>)
      const text = line.message
      if (text && text.includes('-------------------------')) {
        //console.log(text)
        const lineDate = convertTextToDate(text)
        //console.log(lineDate)
        const now = new Date()
        const days = getDifferenceInDays(now, lineDate)
        //console.log(days)
        if (days > 7) {
          break
        }
      }
    }
    rows.reverse()

    return (
      <div style={{ textAlign: 'center', height: '100%', overflow: 'auto', padding: '10px' }}>
        <div style={{ textAlign: 'center', padding: '10pxs' }}>
          <h4 style={{ paddingBottom: '10px' }}>{`Error Report (${sevenDaysAgoString} - ${todayString})`}</h4>
          <Table bordered size="sm" style={{ width: 'auto', margin: 'auto' }}>
            <tbody>
              <tr><td style={{ textAlign: 'left' }}>{rows}</td></tr>
            </tbody>
          </Table>
        </div>
      </div>
    )
  }
  return ''
}
